import type { FC } from "react";
import { lazy, Suspense } from "react";

import { isDevelopment } from "@shared/utils";

const ReactAxe = lazy(() => import("./ReactAxe"));

const LazyReactAxe: FC = () => {
  if (!isDevelopment() || !process.env.REACT_AXE_ENABLED) return null;

  return (
    <Suspense fallback={null}>
      <ReactAxe />
    </Suspense>
  );
};

export { LazyReactAxe };
